module.exports = __webpack_public_path__ + "static/asientos-tapizados-ef9cb260fe4589af7a3f3122e5f20847.jpg";